import { Autocomplete, TextField } from "@mui/material";
import { useEffect } from "react";

import useResearchTypeSelect_GetAutocompleteOptions from "./api/useResearchTypeSelect_GetAutocompleteOptions";

type ResearchTypeSelectProps = {
    label: string;
    value?: string[] | null;
    projectIds?: string[];
    onChange: (value: string[]) => void;
};

export default function ResearchTypeSelect({ label, value, projectIds, onChange }: ResearchTypeSelectProps) {
    const { options, scrubbedSelectedIds, selectedIdsIsScrubbed, loading } = useResearchTypeSelect_GetAutocompleteOptions({
        projectIds: projectIds,
        selectedIds: value,
    });

    // Drop research type ids from the url that are not available for the current project scope.
    useEffect(() => {
        if (!selectedIdsIsScrubbed) return;

        onChange(scrubbedSelectedIds);
    }, [onChange, scrubbedSelectedIds, selectedIdsIsScrubbed]);

    const selectedValue = options.filter(o => value?.includes(o.value));

    return (
        <Autocomplete
            multiple
            options={options}
            isOptionEqualToValue={(option, selected) => option.value === selected.value}
            loading={loading}
            getOptionKey={option => option.value}
            getOptionLabel={option => option.label}
            value={selectedValue}
            onChange={(_, newValue) => onChange(newValue.map(x => x.value))}
            renderInput={params => <TextField {...params} fullWidth variant="outlined" label={label} />}
        />
    );
}
